/**
 * PaymentTrustBadges - SSL and HIPAA trust indicators
 *
 * Displays security badges to build user trust
 */

const TRUST_BADGES = [
  {
    id: 'ssl',
    label: 'SSL SECURE',
    icon: '/images/icons/payment-page-v2/icon-ssl-lock.svg',
  },
  {
    id: 'hipaa',
    label: 'HIPAA ALIGNED',
    icon: '/images/icons/payment-page-v2/icon-caduceus.svg',
  },
] as const;

export function PaymentTrustBadges() {
  return (
    <div className="flex items-center justify-center gap-6">
      {TRUST_BADGES.map((badge) => (
        <div key={badge.id} className="flex items-center gap-1.5">
          <img
            src={badge.icon}
            alt=""
            className="h-4 w-4 opacity-50"
          />
          <span className="text-xs font-medium uppercase tracking-wide text-slate-400">
            {badge.label}
          </span>
        </div>
      ))}
    </div>
  );
}

export default PaymentTrustBadges;
